import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';

// Pages - Public
import Landing from './pages/Landing';
import Products from './pages/Products';
import Login from './pages/Login';
import Debug from './pages/Debug';

// Pages - Admin
import AdminDashboard from './pages/AdminDashboard';
import AdminProducts from './pages/AdminProducts';
import AdminOrders from './pages/AdminOrders';
import AdminProvisioning from './pages/AdminProvisioning';
import AdminCustomers from './pages/AdminCustomers';
import AdminDomainSettings from './pages/AdminDomainSettings';

// Components
import { AdminRoute } from './components/AdminRoute';

// Private Route Component (for admin auth)
function PrivateRoute({ children }) {
  const { token } = useAuthStore();
  return token ? children : <Navigate to="/login" />;
}

function App() {
  const { token, user, loadProfile } = useAuthStore();
  const [initialized, setInitialized] = React.useState(false);

  // Load user profile on mount if token exists
  useEffect(() => {
    if (token && !user) {
      loadProfile().then(() => setInitialized(true));
    } else {
      setInitialized(true);
    }
  }, [token, user, loadProfile]);

  if (!initialized) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* Public Routes - Learning Site */}
        <Route path="/" element={<Landing />} />
        <Route path="/products" element={<Products />} />
        <Route path="/debug" element={<Debug />} />

        {/* Admin Routes (requires authentication) */}
        <Route path="/login" element={token ? <Navigate to="/admin" /> : <Login />} />

        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/products"
          element={
            <PrivateRoute>
              <AdminRoute>
                <AdminProducts />
              </AdminRoute>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/orders"
          element={
            <PrivateRoute>
              <AdminRoute>
                <AdminOrders />
              </AdminRoute>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/provisioning"
          element={
            <PrivateRoute>
              <AdminRoute>
                <AdminProvisioning />
              </AdminRoute>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/customers"
          element={
            <PrivateRoute>
              <AdminRoute>
                <AdminCustomers />
              </AdminRoute>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/domain-settings"
          element={
            <PrivateRoute>
              <AdminRoute>
                <AdminDomainSettings />
              </AdminRoute>
            </PrivateRoute>
          }
        />

        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;

